export default __webpack_public_path__ + "static/media/suit-4.81ebe085.jpg";